/**
 * Map Enum values from BE to strings to display.
 */
export const PASSPORT_STATUS_LABELS = {
    REQUESTED:       'Beantragt (Requested)',
    RETURNED:        'Überarbeitung (Returned)',
    RESENT:          'Resent',
    CHANGED:         'Pass Änderung (Passport change)',
    APPROVED:        'Genehmigt (Approved)',
    CHANGE_DECLINED: 'Änderung abgelehnt (Change Declined)',
    REJECTED:        'Abgelehnt (Rejected)',
    ACTIVE:          'Gültig (Valid)',
    DEACTIVATED:     'Ungültig (Invalid)',
    PRE_REQUEST:     'Entwurf (Draft)',
};

/**
 * @param {string|null|undefined} statusValue
 * @returns {string}
 */
export function getPassportStatusLabelFromEnumKey(statusValue) {
    if (!statusValue) return '';
    return PASSPORT_STATUS_LABELS[statusValue] ?? statusValue;
}
